import { render } from "./GoogleSSO.vue?vue&type=template&id=6190cfdb"
import script from "./GoogleSSO.vue?vue&type=script&lang=js"
export * from "./GoogleSSO.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__